<template>
	<el-config-provider :locale="language === 'en' ? en : zhCn">
		<router-view />
		<Airplane />
	</el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import en from 'element-plus/dist/locale/en.mjs'
import { useStore } from 'vuex'
import { computed } from 'vue'
import Airplane from '@/components/Airplane.vue'

const store = useStore()
const language = computed(() => store.getters['common/language'])
</script>

<style lang="less">
@import '@/assets/font/font.css';

#app {
	/*font-family: 'Montserrat-ExtraBold', sans-serif;*/
	font-family: 'Montserrat-Regular', sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
}
</style>
